module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-wrapper"
  }, [_c('v-autocomplete', {
    attrs: {
      "id": _vm.id,
      "items": _vm.contacts,
      "get-label": _vm.getLabel,
      "component-item": _vm.item_contact,
      "input-attrs": _vm.attrs,
      "auto-select-one-item": false
    },
    on: {
      "update-items": _vm.searchContacts,
      "item-selected": _vm.addContact
    },
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "align": "right"
    }
  }, [_c('loading', {
    attrs: {
      "loading": "loading",
      "size": "20px"
    }
  })], 1) : _vm._e(), (_vm.show_no_result_found_message) ? _c('div', {
    staticClass: "no-result-found"
  }, [_vm._v(_vm._s(_vm.$t('contacts.feedback.noSearchResults')))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-305a09fc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/contacts.vue
// module id = 1065
// module chunks = 1